module.exports = __webpack_public_path__ + "static/media/loyaltymj.a42df22b.png";